import { defineMessage } from '@lingui/macro';

import BaseAddSquareIcon from './add-square.svg';
import BaseAddUserIcon from './add-user.svg';
import BaseBackIcon from './back.svg';
import BaseBellIcon from './bell.svg';
import BaseCheckThinIcon from './check-thin.svg';
import BaseCheckIcon from './check.svg';
import BaseClockIcon from './clock.svg';
import BaseCloseIcon from './close.svg';
import BaseDarkModeIcon from './dark-mode.svg';
import BaseDocumentCodeIcon from './document-code.svg';
import BaseDotIcon from './dot.svg';
import BaseDropdownIcon from './dropdown.svg';
import BaseEthereumIcon from './ethereum.svg';
import BaseExploreIcon from './explore.svg';
import BaseExternalLinkIcon from './external-link.svg';
import BaseFilterIcon from './filter.svg';
import BaseFlashIcon from './flash.svg';
import BaseGlobalIcon from './global.svg';
import BaseGlobeIcon from './globe.svg';
import BaseHierarchyIcon from './hierarchy.svg';
import BaseHomeIcon from './home.svg';
import { wrapIcon } from './Icon';
import BaseInfoIcon from './info.svg';
import BaseInteroperabilityIcon from './interoperability.svg';
import BaseKeyIcon from './key.svg';
import BaseLightModeIcon from './light-mode.svg';
import BaseLinkIcon from './link.svg';
import BaseLiveIcon from './live.svg';
import BaseMessagesIcon from './messages.svg';
import BaseMetaMaskIcon from './metamask.svg';
import BaseNotificationIcon from './notification.svg';
import BaseNotificationsIcon from './notifications.svg';
import BaseQuestionIcon from './question.svg';
import BaseSearchFieldIcon from './search-field.svg';
import BaseSearchIcon from './search.svg';
import BaseSecurityKeyIcon from './security-key.svg';
import BaseSecuritySearchIcon from './security-search.svg';
import BaseSnapIcon from './snap.svg';
import BaseSpeedometerIcon from './speedometer.svg';
import BaseTagCircleIcon from './tag-circle.svg';
import BaseTagIcon from './tag.svg';
import BaseTimerIcon from './timer.svg';
import BaseTransactionInsightsIcon from './transaction-insights.svg';
import BaseUserCircleAddIcon from './user-circle-add.svg';
import BaseWarningIcon from './warning.svg';
import BaseWifiIcon from './wifi.svg';

export const AddSquareIcon = wrapIcon(BaseAddSquareIcon, defineMessage`Add`);

export const AddUserIcon = wrapIcon(BaseAddUserIcon, defineMessage`Add user`);

export const BackIcon = wrapIcon(BaseBackIcon, defineMessage`Back`);

export const BellIcon = wrapIcon(BaseBellIcon, defineMessage`Notifications`);

export const ClockIcon = wrapIcon(BaseClockIcon, defineMessage`Clock`);

export const CloseIcon = wrapIcon(BaseCloseIcon, defineMessage`Close`);

export const CheckIcon = wrapIcon(BaseCheckIcon, defineMessage`Check`);

export const CheckThinIcon = wrapIcon(BaseCheckThinIcon, defineMessage`Check`);

export const DarkModeIcon = wrapIcon(
  BaseDarkModeIcon,
  defineMessage`Toggle color mode`,
);

export const DocumentCodeIcon = wrapIcon(
  BaseDocumentCodeIcon,
  defineMessage`Document code`,
);

export const DotIcon = wrapIcon(
  BaseDotIcon,
  defineMessage`Unread notification`,
);

export const DropdownIcon = wrapIcon(BaseDropdownIcon, defineMessage`Dropdown`);

export const EthereumIcon = wrapIcon(BaseEthereumIcon, defineMessage`Ethereum`);

export const ExploreIcon = wrapIcon(BaseExploreIcon, defineMessage`Explore`);

export const ExternalLinkIcon = wrapIcon(
  BaseExternalLinkIcon,
  defineMessage`External link`,
);

export const FilterIcon = wrapIcon(BaseFilterIcon, defineMessage`Filter`);

export const FlashIcon = wrapIcon(BaseFlashIcon, defineMessage`Flash`);

export const GlobalIcon = wrapIcon(BaseGlobalIcon, defineMessage`Global`);

export const GlobeIcon = wrapIcon(BaseGlobeIcon, defineMessage`Language`);

export const HierarchyIcon = wrapIcon(
  BaseHierarchyIcon,
  defineMessage`Hierarchy`,
);

export const HomeIcon = wrapIcon(BaseHomeIcon, defineMessage`Home`);

export const InfoIcon = wrapIcon(BaseInfoIcon, defineMessage`Info`);

export const InteroperabilityIcon = wrapIcon(
  BaseInteroperabilityIcon,
  defineMessage`Interoperability`,
);

export const KeyIcon = wrapIcon(BaseKeyIcon, defineMessage`Key`);

export const LightModeIcon = wrapIcon(
  BaseLightModeIcon,
  defineMessage`Enable light mode`,
);

export const LinkIcon = wrapIcon(BaseLinkIcon, defineMessage`Link`);

export const LiveIcon = wrapIcon(BaseLiveIcon, defineMessage`Live`);

export const MessagesIcon = wrapIcon(BaseMessagesIcon, defineMessage`Messages`);

export const MetaMaskIcon = wrapIcon(BaseMetaMaskIcon, defineMessage`MetaMask`);

export const NotificationIcon = wrapIcon(
  BaseNotificationIcon,
  defineMessage`Notification`,
);

export const NotificationsIcon = wrapIcon(
  BaseNotificationsIcon,
  defineMessage`Notifications`,
);

export const NotificationsCategoryIcon = wrapIcon(
  BaseNotificationsIcon,
  defineMessage`Communication`,
);

export const QuestionIcon = wrapIcon(BaseQuestionIcon, defineMessage`Question`);

export const SearchIcon = wrapIcon(BaseSearchIcon, defineMessage`Search`);

export const SearchFieldIcon = wrapIcon(
  BaseSearchFieldIcon,
  defineMessage`Search`,
);

export const SecurityKeyIcon = wrapIcon(
  BaseSecurityKeyIcon,
  defineMessage`Security key`,
);

export const SecuritySearchIcon = wrapIcon(
  BaseSecuritySearchIcon,
  defineMessage`Security search`,
);

export const SnapIcon = wrapIcon(BaseSnapIcon, defineMessage`Snap`);

export const SpeedometerIcon = wrapIcon(
  BaseSpeedometerIcon,
  defineMessage`Speedometer`,
);

export const TagIcon = wrapIcon(BaseTagIcon, defineMessage`Tag`);

export const TagCircleIcon = wrapIcon(BaseTagCircleIcon, defineMessage`Tag`);

export const TimerIcon = wrapIcon(BaseTimerIcon, defineMessage`Timer`);

export const TransactionInsightsIcon = wrapIcon(
  BaseTransactionInsightsIcon,
  defineMessage`Security`,
);

export const UserCircleAddIcon = wrapIcon(
  BaseUserCircleAddIcon,
  defineMessage`Add user`,
);

export const WarningIcon = wrapIcon(BaseWarningIcon, defineMessage`Warning`);

export const WifiIcon = wrapIcon(BaseWifiIcon, defineMessage`Wifi`);

export type { IconProps } from './Icon';
